import api from './api';
import {
  PopupGuide,
  PopupGuidePayload,
  PopupGuideUploadedImage,
  PopupGuideListResponse,
  ApiResponseEnvelope,
} from '../types/popup';

const toEnvelope = <T>(response: any): ApiResponseEnvelope<T> => {
  return response.data as ApiResponseEnvelope<T>;
};

export const popupGuidesService = {
  async getGuides(params?: {
    page?: number;
    limit?: number;
    exposure?: string;
    search?: string;
  }): Promise<PopupGuideListResponse> {
    const queryParams = new URLSearchParams();

    if (params?.page) queryParams.append('page', params.page.toString());
    if (params?.limit) queryParams.append('limit', params.limit.toString());
    if (params?.exposure && params.exposure !== '전체') {
      queryParams.append('exposure', params.exposure === '노출' ? 'show' : 'hide');
    }
    if (params?.search) queryParams.append('search', params.search);

    const response = await api.get(`/popup-guides?${queryParams.toString()}`);
    const { data } = toEnvelope<PopupGuideListResponse>(response);
    return data;
  },

  async getGuide(id: number | string): Promise<PopupGuide> {
    const response = await api.get(`/popup-guides/${id}`);
    const { data } = toEnvelope<PopupGuide>(response);
    return data;
  },

  async createGuide(payload: PopupGuidePayload): Promise<PopupGuide> {
    const response = await api.post('/popup-guides', payload);
    const { data } = toEnvelope<PopupGuide>(response);
    return data;
  },

  async updateGuide(id: number | string, payload: Partial<PopupGuidePayload>): Promise<PopupGuide> {
    const response = await api.put(`/popup-guides/${id}`, payload);
    const { data } = toEnvelope<PopupGuide>(response);
    return data;
  },

  async deleteGuide(id: number | string): Promise<void> {
    await api.delete(`/popup-guides/${id}`);
  },

  async deleteGuides(ids: (number | string)[]): Promise<void> {
    await api.post('/popup-guides/bulk-delete', { ids });
  },

  async updateExposure(ids: (number | string)[], exposure: 'show' | 'hide'): Promise<void> {
    await api.patch('/popup-guides/bulk-exposure', { ids, exposure });
  },

  async getLayouts(): Promise<string[]> {
    const response = await api.get('/popup-guides/layouts');
    const { data } = toEnvelope<string[]>(response);
    return data;
  },

  async uploadImages(files: File[]): Promise<PopupGuideUploadedImage[]> {
    if (!files.length) {
      return [];
    }

    const formData = new FormData();
    files.forEach((file) => {
      formData.append('images', file);
    });

    const response = await api.post('/upload/images', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });

    const { data } = toEnvelope<PopupGuideUploadedImage[]>(response);
    return data;
  },

  async downloadImagesZip(id: number | string): Promise<Blob> {
    const response = await api.get(`/popup-guides/${id}/images/download`, {
      responseType: 'blob',
    });
    return response.data;
  },
};

export default popupGuidesService;